import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBalance } from '@features/balance';
import { useAccountings } from '@features/accounting';
import { BalanceBanner } from '@widgets/balance/balance-banner';
import { BalanceCards } from '@widgets/balance/balance-cards';
import { BalancePageSkeleton, Button, StatusBanner } from '@shared/ui';
import { AccountingTable } from '@widgets/accounting/accounting-table';
import { MerchantAmlCharges } from '@widgets/aml-charges';

export function BalancePage() {
  const { t } = useTranslation('cabinet');
  const [page, setPage] = useState(1);

  const {
    balance,
    isLoading: isBalanceLoading,
    error: balanceError,
    mutate: mutateBalance,
  } = useBalance();
  const {
    operations,
    pagination,
    isLoading: isAccountingsLoading,
    error: accountingsError,
    mutate: mutateAccountings,
  } = useAccountings(page);

  if (isBalanceLoading && !balance) {
    return <BalancePageSkeleton />;
  }

  return (
    <div className="page-stack">
      {balanceError ? (
        <StatusBanner>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <span>{balance ? t('withdrawals.stale') : t('withdrawal.modal.balanceLoadError')}</span>
            <Button type="button" variant="outline" size="sm" className="w-full sm:w-auto" onClick={() => void mutateBalance()}>
              {t('common.retry', { ns: 'common' })}
            </Button>
          </div>
        </StatusBanner>
      ) : null}
      {balance || !balanceError ? (
        <BalanceBanner
          total={balance?.totalBalance ?? null}
          reserved={balance?.reservedBalance ?? null}
          available={balance?.availableBalance ?? null}
        />
      ) : null}

      {balance ? <BalanceCards balances={balance.assetBalances} /> : balanceError ? null : <BalanceCards balances={[]} />}

      <MerchantAmlCharges />

      <AccountingTable
        operations={operations}
        pagination={pagination}
        isLoading={isAccountingsLoading}
        error={accountingsError}
        onRefresh={() => void mutateAccountings()}
        onPageChange={setPage}
      />
    </div>
  );
}
